import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { getCurrentUserInfo } from '../../redux/actions/currentUserActions';
import {
  editText,
  infoText,
  staffText,
  devicesText,
} from '../shared/SharedInternationalizations';
import permissions from '../../permissionsList';
import AccessControl from '../../AccessControl';
import { FormattedMessage, FormattedDate } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import UserInfo from '../user/userDisplay/UserInfo';
import UserStaffProfile from '../user/userDisplay/UserStaffProfile';
import UserDevices from '../user/userDisplay/UserDevices';
import { loadAlarmDeviceTypes } from '../../redux/actions/alarmDeviceActions';
import { loadAlertDeviceTypes } from '../../redux/actions/alertDeviceActions';

export function UnconnectedProfileDisplay(props) {
  const { currentUser, alarmDeviceTypes, alertDeviceTypes } = props;
  const location = useLocation();
  const { search } = location;
  const searchParams = new URLSearchParams(search);
  const view = searchParams.get('view');

  useEffect(() => {
    if (!currentUser?.id) {
      props.dispatch(getCurrentUserInfo());
    }

    if (!alarmDeviceTypes || Object.keys(alarmDeviceTypes).length === 0) {
      props.dispatch(loadAlarmDeviceTypes());
    }

    if (!alertDeviceTypes || Object.keys(alertDeviceTypes).length === 0) {
      props.dispatch(loadAlertDeviceTypes());
    }
  }, []);

  const currentLocation = location.pathname + location.search;
  let userObj = currentUser;

  function displayInfo() {
    switch (view) {
      case 'devices':
        return (
          <UserDevices
            data-test="devices-component"
            id={userObj.id}
            userObj={userObj}
            currentLocation={currentLocation}
            alarmDeviceList={userObj.alarm_devices}
            alertDeviceList={userObj.alert_devices}
          />
        );

      case 'staff':
        return (
          <UserStaffProfile
            data-test="staff-profile-component"
            staffPreferences={userObj.preferences}
            currentLocation={currentLocation}
            userObj={userObj}
          />
        );

      default:
        return (
          <UserInfo
            data-test="info-component"
            user={userObj}
            currentLocation={currentLocation}
          />
        );
    }
  }
  const userDisplayName = `${userObj.title ? userObj.title : ''} ${
    userObj.first_name
  } ${userObj.preferred_name ? `"${userObj.preferred_name}"` : ''} ${
    userObj.middle_name ? userObj.middle_name : ''
  } ${userObj.last_name} ${userObj.suffix ? userObj.suffix : ''}`;

  return (
    <div className="container" data-test="user-display">
      <FormattedMessage
        id="myProfile.browserTabInfo"
        defaultMessage="Users | {username}"
        description="Done button"
        values={{
          username: `${userObj.title ? userObj.title : ''} ${
            userObj.first_name ? userObj.first_name : ''
          } ${userObj.last_name ? userObj.last_name : ''} ${
            userObj.suffix ? userObj.suffix : ''
          }`,
        }}>
        {(txt) => (
          <Helmet>
            <title>{txt}</title>
          </Helmet>
        )}
      </FormattedMessage>
      <div className="layout-container content-container content-container--column content-container--shadow">
        <div
          className="content-display__container content-display__container--column align-center"
          data-test="user-name-title">
          <FormattedMessage
            id="profileDisplay.usernameDisplayText"
            data-test="header-text-wrapper"
            defaultMessage="View Details for User: {user}"
            description="The title for the page to edit a unit"
            values={{
              user: userDisplayName,
            }}>
            {(txt) => (
              <h1
                className="no-margin text-deep-blue text-center"
                data-test="header-text">
                {txt}
              </h1>
            )}
          </FormattedMessage>
          <span>
            <FormattedMessage
              id="profileDisplay.lastLogin"
              data-test="header-text-wrapper"
              defaultMessage="Last login:"
              description="The title for the page to edit a unit"
            />
            <span className="margin-left-10">
              <FormattedDate
                value={new Date(userObj.last_login)}
                year="numeric"
                month="2-digit"
                day="2-digit"
              />
            </span>
          </span>
        </div>
        <div className="tab-bar" data-test="tab-bar">
          <Link
            to="/myProfile/"
            className={
              view === null
                ? 'text-medium tab-bar__tab tab-bar__tab--active'
                : 'text-medium  tab-bar__tab'
            }
            data-test="info-tab">
            {infoText}
          </Link>

          <Link
            to="/myProfile/?view=staff"
            className={
              view === 'staff'
                ? 'text-medium tab-bar__tab tab-bar__tab--active'
                : 'text-medium  tab-bar__tab'
            }
            data-test="staff-tab">
            {staffText}
          </Link>

          <Link
            to="/myProfile/?view=devices"
            className={
              view === 'devices'
                ? 'text-medium tab-bar__tab tab-bar__tab--active'
                : 'text-medium  tab-bar__tab'
            }
            data-test="devices-tab">
            {devicesText}
          </Link>
        </div>
        {displayInfo()}
        <AccessControl
          data-test="access-control"
          feature={permissions.static.users.editUser}
          userToEdit={userObj.id}>
          <div className="flex-spread width-100 flex-end">
            <div className="flex-end align-center">
              <Link
                className="link-button button-secondary button-sm text-medium-small margin-left-15"
                to={`/users/${userObj.id}/edit/`}
                state={{
                  modal: true,
                  user: userObj.id,
                  previous: currentLocation,
                }}>
                {editText}
              </Link>
            </div>
          </div>
        </AccessControl>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser,
    unitsObj: state.units.units,
    alarmDeviceTypes: state.devices.alarmDeviceTypes,
    alertDeviceTypes: state.devices.alertDeviceTypes,
  };
};

export default connect(mapStateToProps)(UnconnectedProfileDisplay);
